(function () {
  // ---- Sticky nav state ----
  const nav = document.getElementById('topnav');
  if (nav) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 60) nav.classList.add('scrolled');
      else nav.classList.remove('scrolled');
    }, { passive: true });
  }

  // ---- Hero parallax ----
  const heroBg = document.getElementById('hero-bg');
  const skuHeroBg = document.getElementById('sku-hero-bg');
  if (heroBg || skuHeroBg) {
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (heroBg) heroBg.style.transform = `translateY(${y * 0.3}px)`;
      if (skuHeroBg) {
        const skuTop = skuHeroBg.parentElement.offsetTop;
        skuHeroBg.style.transform = `translateY(${(y - skuTop) * 0.3}px)`;
      }
    }, { passive: true });
  }

  // ---- Reveal on scroll ----
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) entry.target.classList.add('in');
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });
    reveals.forEach(el => revealObserver.observe(el));
  }

  // ---- Number counters ----
  const counters = document.querySelectorAll('[data-counter]');
  if (counters.length) {
    const counterObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.dataset.done) {
          const target = parseInt(entry.target.dataset.counter, 10);
          const duration = 1600;
          const startTime = performance.now();
          const animate = (t) => {
            const elapsed = t - startTime;
            const p = Math.min(elapsed / duration, 1);
            const eased = 1 - Math.pow(1 - p, 3);
            entry.target.textContent = Math.floor(target * eased);
            if (p < 1) requestAnimationFrame(animate);
            else entry.target.textContent = target;
          };
          requestAnimationFrame(animate);
          entry.target.dataset.done = '1';
        }
      });
    }, { threshold: 0.5 });
    counters.forEach(el => counterObserver.observe(el));
  }

  // ---- SKU sticky nav active state ----
  const stickyLinks = document.querySelectorAll('.sku-sticky a');
  if (stickyLinks.length) {
    const sectionMap = {};
    stickyLinks.forEach(a => {
      sectionMap[a.dataset.target] = document.getElementById(a.dataset.target);
    });
    const stickyObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const id = entry.target.id;
          stickyLinks.forEach(a => a.classList.toggle('active', a.dataset.target === id));
        }
      });
    }, { threshold: 0.35, rootMargin: '-150px 0px -50% 0px' });
    Object.values(sectionMap).forEach(s => { if (s) stickyObserver.observe(s); });
  }

  // ---- FAQ toggle ----
  document.querySelectorAll('.faq-q').forEach(q => {
    q.addEventListener('click', () => q.closest('.faq-item').classList.toggle('open'));
  });

  // ---- Cart count from Shopify Ajax API ----
  const cartCountEl = document.getElementById('cart-count');
  const refreshCartCount = async () => {
    if (!cartCountEl) return;
    try {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await r.json();
      cartCountEl.textContent = cart.item_count || 0;
    } catch (e) { /* ignore */ }
  };
  refreshCartCount();

  // ---- Origin card quick-add (homepage) ----
  document.querySelectorAll('.origin-quickadd').forEach(btn => {
    const fire = async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.classList.add('adding');
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        btn.classList.add('added');
        const original = btn.textContent;
        btn.textContent = '✓';
        await refreshCartCount();
        setTimeout(() => { btn.classList.remove('added'); btn.textContent = original; }, 1400);
      } catch (err) {
        console.error('quick-add failed', err);
      } finally {
        btn.classList.remove('adding');
      }
    };
    btn.addEventListener('click', fire);
    btn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') fire(e);
    });
  });

  // ---- PDP qty + add-to-cart (in-page + sticky bar synced) ----
  const qtyNum = document.getElementById('qty-num');
  const qtyPlus = document.getElementById('qty-plus');
  const qtyMinus = document.getElementById('qty-minus');
  const addBtn = document.getElementById('add-btn');
  const addedMark = document.getElementById('added-mark');
  const sQtyNum = document.getElementById('sticky-qty-num');
  const sQtyPlus = document.getElementById('sticky-qty-plus');
  const sQtyMinus = document.getElementById('sticky-qty-minus');
  const sAddBtn = document.getElementById('sticky-add-btn');
  const sPrice = document.getElementById('stickyPrice');

  if (qtyNum && addBtn) {
    const unitPrice = parseFloat(addBtn.dataset.unitPrice || '0');
    const variantId = addBtn.dataset.variantId;
    const fmt = (cents) => '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    let qty = 1;
    const setQty = (n) => {
      qty = Math.max(1, Math.min(9, n));
      qtyNum.textContent = qty;
      if (sQtyNum) sQtyNum.textContent = qty;
      if (sPrice && unitPrice) sPrice.textContent = fmt(unitPrice * qty);
    };
    qtyPlus && qtyPlus.addEventListener('click', () => setQty(qty + 1));
    qtyMinus && qtyMinus.addEventListener('click', () => setQty(qty - 1));
    sQtyPlus && sQtyPlus.addEventListener('click', () => setQty(qty + 1));
    sQtyMinus && sQtyMinus.addEventListener('click', () => setQty(qty - 1));

    const addToCart = async () => {
      if (!variantId) return;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty }),
        });
        if (addedMark) {
          addedMark.classList.add('show');
          setTimeout(() => addedMark.classList.remove('show'), 2200);
        }
        await refreshCartCount();
      } catch (err) {
        console.error('add-to-cart failed', err);
      }
    };
    addBtn.addEventListener('click', addToCart);
    sAddBtn && sAddBtn.addEventListener('click', addToCart);
  }

  // ---- PDP gallery: thumbnail click swaps main image ----
  document.querySelectorAll('.pdp-gallery').forEach(gallery => {
    const mainImg = gallery.querySelector('.pdp-gallery-main img');
    if (!mainImg) return;
    const thumbs = gallery.querySelectorAll('.pdp-thumb');
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.image;
        if (!src) return;
        mainImg.src = src;
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  });

  // ---- Sticky buy bar visibility (PDP only) ----
  // Show whenever the buy module is OUT of viewport — i.e., the user has scrolled
  // past it into the editorial sections and no buy CTA is currently visible.
  const stickyBuy = document.getElementById('stickyBuy');
  const buySection = document.getElementById('buy-section');
  const skuHero = document.getElementById('sku-hero');
  if (stickyBuy && buySection && skuHero) {
    const updateStickyVis = () => {
      const heroRect = skuHero.getBoundingClientRect();
      const buyRect = buySection.getBoundingClientRect();
      const vh = window.innerHeight;
      const buyInView = buyRect.bottom > 80 && buyRect.top < vh - 60;
      const show = heroRect.bottom < 80 && !buyInView;
      stickyBuy.classList.toggle('visible', show);
      stickyBuy.setAttribute('aria-hidden', show ? 'false' : 'true');
    };
    window.addEventListener('scroll', updateStickyVis, { passive: true });
    window.addEventListener('resize', updateStickyVis);
    updateStickyVis();
  }
})();
